import dayjs from 'dayjs';
import { IonButton } from '@ionic/react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { DuoCalendarDaysIcon } from '../theme/Icons';
import { CheckinState } from './model/CheckinState';
import { Card } from '../components/Card';
import { Text } from '../components/Text';
import { IFeeling } from './model/ICheckin';
import { MouseEvent } from 'react';
import { FeelingSelector } from './details/FeelingSelector';
import { HistoryViewModel } from '../support/HistoryViewModel';
import { MixPanelEventEmitter } from '../metrics/MixPanelEventEmitter';

export const CheckinCard: React.FC = () => {
    const history = useInstance(HistoryViewModel);
    const mixpanel = useInstance(MixPanelEventEmitter);

    const checkinState = useInstance(CheckinState);
    useSubscription(() => checkinState);

    if (!checkinState.state) {
        return null;
    }

    const todayCheckin = checkinState.getPersonalCheckinForToday();

    const onClickCard = async () => {
        mixpanel.track('Daily Log Opened', () => ({
            'Day': mixpanel.createMixpanelDateWithoutTime(dayjs().format('YYYY-MM-DD')),
            'From': 'caregiver corner'
        }));

        history.push(`/calendar/journal/daily-log`);
    };

    const onClickFeeling = async (feeling?: IFeeling) => {
        mixpanel.track('Daily Log Opened', () => ({
            'Day': mixpanel.createMixpanelDateWithoutTime(dayjs().format('YYYY-MM-DD')),
            'From': 'caregiver corner'
        }));

        const qs = (feeling ? `?feeling=${feeling}` : '');
        history.push(`/calendar/journal/daily-log${qs}`);
    };

    const onClickViewAll = (e: MouseEvent) => {
        e.stopPropagation();
        mixpanel.track('Daily Log Calendar Opened', () => ({'Opened From': 'Home Page'}));
        history.push(`/calendar/journal`);
    };

    return (
        <>
            <Card data-type="checkin-card" padded onClick={onClickCard}>

                <div style={{marginBottom: 12}}>
                    <Text><b>Daily Care Journal</b></Text>
                </div>

                <Text type="detail">How was your day? Track care events and monitor your wellness to promote balanced caregiving.</Text>

                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 30}}>
                    <div style={{marginTop: 5, marginBottom: 5}}>
                        <Text type="detail">Today, {dayjs().format('dddd MMMM Do')}</Text>
                    </div>
                    <div>
                        <IonButton
                            fill="clear"
                            onClick={onClickViewAll}
                            data-id="checkin-calendar-button"
                            style={{'--padding-top': '15px', '--padding-bottom': '15px'}}
                        >
                            <DuoCalendarDaysIcon slot="start" />
                            &nbsp;&nbsp;All Days
                        </IonButton>
                    </div>
                </div>

                <FeelingSelector value={todayCheckin.feeling} onChange={onClickFeeling} />

            </Card>
        </>
    );
};
